import { render, staticRenderFns } from "./AntdSelectMultiColor.vue?vue&type=template&id=6460dbf1&scoped=true&"
import script from "./AntdSelectMultiColor.vue?vue&type=script&lang=js&"
export * from "./AntdSelectMultiColor.vue?vue&type=script&lang=js&"
import style0 from "./AntdSelectMultiColor.vue?vue&type=style&index=0&id=6460dbf1&prod&scoped=true&lang=scss&"
import style1 from "./AntdSelectMultiColor.vue?vue&type=style&index=1&id=6460dbf1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6460dbf1",
  null
  
)

export default component.exports